/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

/* ==========================================================================
   PRÉCOMMANDE (panier) : envoi groupé / envoi séparé
   Voir snippets/precommande-cart.liquid
   ========================================================================== */
(function () {
  var OPEN_KEY = 'moshiPcOpenDrawer';

  function postJSON(url, data) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(data)
    }).then(function (r) { return r.json(); });
  }

  function drawerIsOpen() {
    var d = document.getElementById('sidebar-cart');
    return !!(d && d.getAttribute('aria-hidden') === 'false');
  }

  function reloadPage() {
    try { if (drawerIsOpen()) { sessionStorage.setItem(OPEN_KEY, '1'); } } catch (e) {}
    window.location.reload();
  }

  function setAttr(key, value) {
    var attrs = {};
    attrs[key] = value;
    return postJSON('/cart/update.js', { attributes: attrs });
  }

  // Fixe la quantité du produit "Envoi séparé" dans le panier
  function setFeeQty(feeKey, feeVariant, qty) {
    if (feeKey) { return postJSON('/cart/change.js', { id: feeKey, quantity: qty }); }
    if (qty > 0 && feeVariant) { return postJSON('/cart/add.js', { items: [{ id: parseInt(feeVariant, 10), quantity: qty }] }); }
    return Promise.resolve();
  }

  // Case à cocher "envoi séparé" : pose le nombre de suppléments calculé par le panier (0, 1 ou 2)
  document.addEventListener('change', function (e) {
    var cb = e.target && e.target.closest ? e.target.closest('[data-precommande-split]') : null;
    if (!cb) { return; }
    var box = cb.closest('[data-precommande-box]');
    if (!box) { return; }
    cb.disabled = true;
    box.classList.add('is-loading');
    var key = box.getAttribute('data-attr-key');
    var feeKey = box.getAttribute('data-fee-key');
    var qty = cb.checked ? (parseInt(box.getAttribute('data-fee-split-qty') || '0', 10)) : 0;
    var p = setFeeQty(feeKey, box.getAttribute('data-fee-variant'), qty)
      .then(function () { return setAttr(key, box.getAttribute(cb.checked ? 'data-attr-split' : 'data-attr-grouped')); });
    p.then(reloadPage, reloadPage);
  });

  // Case à cocher "contact avant envoi" (attribut de commande, sans rechargement)
  document.addEventListener('change', function (e) {
    var cb = e.target && e.target.closest ? e.target.closest('[data-precommande-contact]') : null;
    if (!cb) { return; }
    var all = document.querySelectorAll('[data-precommande-contact]');
    for (var i = 0; i < all.length; i++) { all[i].checked = cb.checked; }
    setAttr(cb.getAttribute('data-contact-key'), cb.checked ? cb.getAttribute('data-contact-yes') : '');
  });

  // Synchronisation automatique : ajuste le nombre de suppléments "Envoi séparé" à ce que le panier attend
  // (règle livraison offerte par envoi), et tient à jour l'attribut "Mode d'expédition" (visible sur la commande).
  var busy = false;
  function sync() {
    if (busy) { return; }
    var els = document.querySelectorAll('[data-precommande-sync]:not([data-done])');
    if (!els.length) { return; }
    for (var i = 0; i < els.length; i++) { els[i].setAttribute('data-done', '1'); }
    var el = els[els.length - 1];
    var feeKey = el.getAttribute('data-fee-key');
    var feeQty = parseInt(el.getAttribute('data-fee-qty') || '0', 10);
    var feeExpected = parseInt(el.getAttribute('data-fee-expected') || '0', 10);
    var key = el.getAttribute('data-attr-key');
    var expected = el.getAttribute('data-attr-expected') || '';
    var current = el.getAttribute('data-attr-current') || '';
    if (el.getAttribute('data-contact-clear') === '1') { setAttr(el.getAttribute('data-contact-key'), ''); }

    if (feeQty !== feeExpected) {
      busy = true;
      setFeeQty(feeKey, el.getAttribute('data-fee-variant'), feeExpected)
        .then(function () { return expected !== current ? setAttr(key, expected) : null; })
        .then(reloadPage, reloadPage);
      return;
    }
    if (expected !== current) { setAttr(key, expected); }
  }

  function reopenDrawer() {
    try {
      if (sessionStorage.getItem(OPEN_KEY)) {
        sessionStorage.removeItem(OPEN_KEY);
        var t = document.querySelector('[data-action="open-drawer"][data-drawer-id="sidebar-cart"]');
        if (t) { setTimeout(function () { t.click(); }, 400); }
      }
    } catch (e) {}
  }

  var timer = null;
  function init() {
    reopenDrawer();
    sync();
    if (window.MutationObserver) {
      new MutationObserver(function () {
        clearTimeout(timer);
        timer = setTimeout(sync, 150);
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();

/* ==========================================================================
   GALERIE PAR COULEUR (fiche produit)
   N'affiche que les photos de la couleur choisie (ex. NOYER / FRÊNE BLANC).
   - Actif uniquement sur les produits tagués "galerie-par-couleur"
     (drapeau window.moshiGalleryByColor posé dans templates/product.liquid).
   - Une photo est rattachée à une couleur si son texte alternatif contient
     le nom de la couleur ; une photo sans couleur reste visible partout.
   ========================================================================== */
(function () {
  function norm(s) {
    return String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
  }

  function init() {
    if (!window.moshiGalleryByColor) { return; }
    var gallery = document.querySelector('.Product__Gallery');
    var slideshow = gallery ? gallery.querySelector('.Product__Slideshow') : null;
    var radios = document.querySelectorAll('.ProductForm .ColorSwatch__Radio[data-option-position]');
    if (!slideshow || !radios.length) { return; }

    var position = parseInt(radios[0].getAttribute('data-option-position'), 10) || 1;
    var values = [];
    Array.prototype.forEach.call(radios, function (r) { if (values.indexOf(r.value) === -1) { values.push(r.value); } });

    var cells = Array.prototype.slice.call(slideshow.querySelectorAll('.Product__SlideItem'));
    var tagged = 0;
    cells.forEach(function (cell) {
      var img = cell.querySelector('img');
      var alt = norm(img ? img.getAttribute('alt') : '');
      var hits = values.filter(function (v) { return alt.indexOf(norm(v)) > -1; });
      cell._pcColor = hits.length === 1 ? norm(hits[0]) : null;
      cell._pcPos = cell.getAttribute('data-image-position');
      if (cell._pcColor) { tagged++; }
    });
    if (!tagged) { return; }

    var dots = Array.prototype.slice.call(gallery.querySelectorAll('.Product__SlideshowNavDot, .Product__SlideshowNavImage'));
    var current = null;

    function getFlickity() {
      return (window.Flickity && window.Flickity.data) ? window.Flickity.data(slideshow) : null;
    }

    function apply(value, force) {
      var v = norm(value);
      if (!force && v === current) { return; }
      current = v;

      var keep = cells.filter(function (c) { return !c._pcColor || c._pcColor === v; });
      if (!keep.some(function (c) { return c._pcColor; })) { keep = cells; }

      var flkty = getFlickity();
      var carousel = !!(flkty && flkty.isActive);

      if (carousel) {
        flkty.remove(flkty.getCellElements());
        flkty.append(keep);
      } else {
        cells.forEach(function (c) { if (c.parentNode) { c.parentNode.removeChild(c); } });
        keep.forEach(function (c) { slideshow.appendChild(c); });
      }

      keep.forEach(function (c, i) {
        c.setAttribute('data-image-position-ignoring-video', i);
        c.setAttribute('data-image-position', carousel ? i : c._pcPos);
        c.classList.toggle('is-selected', i === 0);
      });

      var keptIds = keep.map(function (c) { return c.id; });
      dots.forEach(function (d) {
        var target = (d.getAttribute('href') || '').replace('#', '') || ('Image' + d.getAttribute('data-image-id'));
        d.style.display = keptIds.indexOf(target) > -1 ? '' : 'none';
      });

      if (carousel) { flkty.select(0, false, true); flkty.resize(); }
      if (window.lazySizes && window.lazySizes.loader) { window.lazySizes.loader.checkElems(); }
    }

    function selectedValue() {
      var checked = document.querySelector('.ProductForm .ColorSwatch__Radio[data-option-position]:checked');
      return checked ? checked.value : values[0];
    }

    // Avant que le thème ne réagisse (phase de capture) : la photo de la variante sera déjà en place.
    document.addEventListener('change', function (e) {
      var r = e.target;
      if (r && r.classList && r.classList.contains('ColorSwatch__Radio') && r.closest('.ProductForm')) { apply(r.value); }
    }, true);

    // Filet de sécurité (sélecteur mobile, liens ?variant=…)
    document.addEventListener('variant:changed', function (e) {
      var variant = e.detail && e.detail.variant;
      if (variant && variant.options) { apply(variant.options[position - 1]); }
    });

    // Passage ordinateur <-> mobile : le carrousel s'active ou se désactive, on reconstruit.
    var wasCarousel = null, t = null;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        var f = getFlickity(); var c = !!(f && f.isActive);
        if (c !== wasCarousel) { wasCarousel = c; apply(selectedValue(), true); }
      }, 250);
    });

    apply(selectedValue(), true);
    var f0 = getFlickity(); wasCarousel = !!(f0 && f0.isActive);
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();
